export const POST_VALIDATE_ACCESS_LINK = 'access-links/validate';
